import React from "react";
import { assets } from "../../../Assets/assets";
import LabelHeading from "../../common/LabelHeading";

const Principles = ({ id }) => {
  return (
    <section id={id} className="w-full bg-white md:py-16 py-8">
      <div className="max-w-[1400px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

        <div className="space-y-6">

          <LabelHeading
            label="Principles"
            heading="Core Principles"
            position="left"
          />

          <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100" className="text-secondaryTextColor text-justify md:text-left leading-relaxed text-[15px] font-DmSans">
            Client value creation is of utmost importance to us, and we aim to build
            lasting relationships with our existing and prospective clients by providing
            them with exceptional services that enable them to become high-performance
            businesses.
          </p>

          <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200" className="text-secondaryTextColor text-justify md:text-left leading-relaxed text-[15px] font-DmSans">
            Diversity is a cornerstone of our company, founded on the value of respect
            for individuals irrespective of their backgrounds. As responsible corporate
            citizens, we embrace and celebrate differences, including working and thinking
            styles, capabilities, preferences, needs, age, gender, ethnicity, nationality,
            and religion—valuing the rich variety of ideas and approaches that result from
            these differences.
          </p>

          <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300" className="text-secondaryTextColor text-justify md:text-left leading-relaxed text-[15px] font-DmSans">
            We strongly believe that persistence and hard work are key to success and strive
            to uphold and reward these values in our daily operations. Humility is also a key
            value, and we always strive to be respectful and courteous towards everyone,
            regardless of circumstances.
          </p>

        </div>

        <div data-aos="fade-up-left" data-aos-duration="1000" className="flex justify-center">
          <img
            src={assets.principlesimg}
            alt="Core Principles"
            className="rounded-lg shadow-xl w-full h-[350px] md:h-[450px] object-cover"
          />
        </div>

      </div>
    </section>
  );
};

export default Principles;
